<template>
  <Modal full :loading="!course" v-on="$listeners">
    <template v-if="course">
      <div class="course">
        <GnaviCourseInfo :course="course" />
        <template v-if="!onlySeat(course.kind)">
          <div v-if="course.kind !== 5" class="menu">
            <div class="head">
              <span class="title">コース内容</span>
              <span v-if="course.menu.count" class="num">全{{ course.menu.count }}品</span>
            </div>
            <div class="inner">
              <p class="text clamp">{{ course.menu.text }}</p>
            </div>
            <div v-if="course.menu.notes.length" class="notes">
              <b>コースに関する備考</b>
              <p v-for="(item, i) in course.menu.notes" :key="i">{{ item }}</p>
            </div>
          </div>
          <div v-if="course.drinkMenu.items.length" class="menu">
            <div class="head">
              <span class="title">ドリンクメニュー</span>
              <span v-if="course.drinkMenu.count.num" class="num">
                {{ course.drinkMenu.count.prefix }}{{ course.drinkMenu.count.num }}品{{ course.drinkMenu.count.suffix }}
              </span>
            </div>
            <div class="inner">
              <div v-for="(item, i) in course.drinkMenu.items" :key="i">
                <b>{{ item.genre }}</b>
                <p class="drink clamp">{{ item.name }}</p>
              </div>
            </div>
            <div v-if="course.drinkMenu.notes.length" class="notes">
              <b>ドリンクに関する備考</b>
              <p v-for="(item, i) in course.drinkMenu.notes" :key="i">{{ item }}</p>
            </div>
          </div>
          <div v-if="course.notes.length" class="menu">
            <div class="head">
              <span class="title">コースに関する注意事項</span>
            </div>
            <div class="inner">
              <div>
                <p v-for="(item, i) in course.notes" :key="i">{{ item }}</p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template #footer>
      <Button primary @click="onReserve(course)">このコースで予約する</Button>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '@/components/molecules/Modal'
import GnaviCourseInfo from '@/components/molecules/GnaviCourseInfo'
import Button from '@/components/atoms/Button'

export default {
  name: 'GnaviCourseModal',
  components: {
    Modal,
    GnaviCourseInfo,
    Button,
  },
  props: {
    id: { type: Number, required: true },
  },
  computed: {
    ...mapState({
      gnaviCourses: state => state.gnaviCourses,
    }),
    course() {
      return this.gnaviCourses.byId[this.id]
    },
  },
  methods: {
    onReserve(course) {
      this.$emit('reserve', course)
    },
    onlySeat(kind) {
      return !!kind && kind === 6
    },
  },
}
</script>

<style lang="postcss" scoped>
.course {
  display: grid;
  grid-gap: 24px 0;
}

.calendar {
  background: #eee;
  grid-area: calendar;
}

.menu {
  display: grid;
  grid-gap: 16px;
}

.head {
  align-items: center;
  background: #eee;
  display: flex;
  line-height: 1;
  margin: 0 -16px;
  padding: 10px 16px;

  @media screen and (min-width: 768px) {
    margin: 0;
    padding: 12px 10px;
  }
}

.title {
  font-weight: bold;
  @media screen and (min-width: 768px) {
    font-size: 16px;
  }
}

.num {
  color: #333;
  font-size: 12px;
  margin-left: 10px;
  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
}

.inner {
  color: #333;
  display: grid;
  font-size: 12px;
  grid-gap: 16px;
  white-space: pre-wrap;
  word-wrap: break-word;
  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
}

.text {
  -webkit-line-clamp: 50;
}

.drink {
  font-size: 12px;
  -webkit-line-clamp: 5;
}

.notes {
  font-size: 12px;
}

.button {
  margin: 0 auto;
}

.clamp {
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}
</style>
